import {Loading} from '@hm/fundamental'
import {buildFeatureUrl, usePlantHierarchyQuery} from '@hproduce/suite-core'
import React from 'react'
import {Navigate, useParams} from 'react-router'

import {NoHierarchyPage} from './NoHierarchyPage'

/**
 * Redirects from /:featureName to /:featureName/hierarchyId/:defaultHierarchyId
 * when user navigates to a feature without specifying a hierarchyId
 */
export const HierarchyIdRedirect: React.FC = () => {
  const {featureName} = useParams<{featureName: string}>()

  if (!featureName) {
    throw new Error(
      'HierarchyIdRedirect must be used within a route that provides :featureName param'
    )
  }
  const {data: plantHierarchy, isPending} = usePlantHierarchyQuery()

  if (isPending) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loading size="xlarge" data-cy="hierarchy_loader" />
      </div>
    )
  }

  const defaultHierarchyId = plantHierarchy?.[0]?.hierarchyId

  if (!defaultHierarchyId) {
    return <NoHierarchyPage />
  }

  return <Navigate to={buildFeatureUrl(featureName, defaultHierarchyId)} replace />
}
